/* eslint-disable quote-props */

import materialTable from './materialTable';
import filter from './filter';
import addons from './crud/addons';
import subscriptions from './crud/subscriptions';
import push from './crud/push';
import form from './form';
import images from './images';
import dashboards from './crud/dashboards';
import files from './crud/files';
import specialties from './crud/specialties';
import packs from './crud/packs';
import epayTransactions from './crud/epayTransactions';
import products from './crud/products';
import pins from './crud/pins';
import doctorSchedules from './crud/doctorSchedules';
import chats from './crud/chats';
import utils from './utils';
import faq from './crud/faq';
import peoples from './crud/peoples';
import event from './crud/event';
import tourImage from './crud/tourImage';
import cards from './crud/cards';
import coupon from './crud/coupon';
import partner from './crud/partner';
import corporation from './crud/corporation';
import packageBilling from './crud/packageBilling';
import planBilling from './crud/planBilling';
import medicalAppointments from './crud/medicalAppointments';
import medicalAppointmentActivities from './crud/medicalAppointmentActivities';
import activities from './crud/activities';
import appointmentCategories from './crud/appointmentCategories';
import appointmentTags from './crud/appointmentTags';
import action from './components/action';
import constants from './components/constants';
import table from './components/table';
import medicalRecords from './crud/medicalRecords';
import medicalRecordEvolutions from './crud/medicalRecordEvolutions';
import corporationPaymentServices from './crud/corporationPaymentServices';
import userActives from './crud/reports/userActives';
import reportsEpay from './crud/reports/reportsEpay';
import reportsMercadoPago from './crud/reports/reportsMercadoPago';
import reportsCielo from './crud/reports/reportsCielo';
import packageActives from './crud/reports/packageActives';
import reportsAsaas from './crud/reports/reportsAsaas';
import reportsIdsIntegration from './crud/reports/reportsIdsIntegration';
import SIDMedicalAppointmentsReports from './crud/reports/SIDMedicalAppointmentsReports';
import packageEspecialtyActives from './crud/reports/packageEspecialtyActives';
import sales from './crud/reports/sales';
import accidentReports from './crud/reports/accidentReports';
import appointmentRating from './crud/reports/appointmentRating';
import logsReports from './crud/reports/logsReports';
import pendingFiles from './crud/pendingFiles';
import activeClients from './crud/reports/activeClients';
import stationReport from './crud/reports/stationReport';
import whatsappCampaign from './crud/whatsappCampaign';
import appointmentConfirmation from './crud/appointmentConfirmation';
import preRegistrationCampaign from './crud/preRegistrationCampaign';
import infobipAccess from './crud/infobipAccess';

import { appName } from '../../../config/uri';

export default {
  adm: {
    materialTable,
    ...filter,
    ...addons,
    ...subscriptions,
    ...push,
    ...utils,
    ...form,
    ...faq,
    ...peoples,
    ...event,
    ...images,
    ...dashboards,
    ...files,
    ...specialties,
    ...packs,
    ...products,
    ...pins,
    ...epayTransactions,
    ...doctorSchedules,
    ...chats,
    ...tourImage,
    ...cards,
    ...coupon,
    ...partner,
    ...corporation,
    ...medicalAppointments,
    ...medicalAppointmentActivities,
    ...activities,
    ...planBilling,
    ...packageBilling,
    ...appointmentCategories,
    ...appointmentTags,
    ...action,
    ...constants,
    ...table,
    ...medicalRecords,
    ...medicalRecordEvolutions,
    ...corporationPaymentServices,
    ...userActives,
    ...packageActives,
    ...packageEspecialtyActives,
    ...reportsEpay,
    ...reportsMercadoPago,
    ...reportsCielo,
    ...reportsAsaas,
    ...reportsIdsIntegration,
    ...sales,
    ...SIDMedicalAppointmentsReports,
    ...accidentReports,
    ...appointmentRating,
    ...logsReports,
    ...pendingFiles,
    ...activeClients,
    ...stationReport,
    ...whatsappCampaign,
    ...appointmentConfirmation,
    ...preRegistrationCampaign,
    ...infobipAccess,
    observation_past_hours: 'Horas passadas nunca estarão habilitadas',
    no_registers: 'Nenhum registro',
    related_schedules: 'Horários relacionados',
    hours_available: 'Horas disponíveis',
    related_appointments: 'Consultas',
    'not-permission-page': 'Você não possuí permissão para acessar está página',
    'not-found-page':
      'A página que você estava buscando não existe ou não está mais disponível',
    'login-title': 'Entrar',
    'login-email': 'E-mail',
    'login-password': 'Senha',
    'login-confirm': 'Entrar',
    'login-failed': 'Erro ao fazer login',
    'login-success': 'Login efetuado com sucesso',
    'login-notadmin': 'Você não é um administrador',

    'menu-user-profile': 'Perfil',
    'menu-user-change-password': 'Alterar Senha',
    'menu-user-logoff': 'Sair',

    permissions_user:
      'PERMISSÕES DO USUÁRIO (visível apenas com usuário na sala)',
    camera_blocked:
      'CÂMERA BLOQUEADA. Solicite que vá até as configurações e dê a permissão de câmera',
    audio_blocked:
      'ÁUDIO BLOQUEADO. Solicite que vá até as configurações e dê a permissão de áudio',

    'menu-dashboard': 'Dashboards',
    'menu-peoples': 'Clientes',
    'menu-medical-appointments': 'Consultas médicas',
    'menu-pending-files': 'Documentos pendentes',
    'menu-medical-appointments-reports': 'Consultas realizadas',
    statistics: 'Estatísticas',
    'menu-send-push': 'Envio de Push',
    'menu-cards': 'Card',
    'menu-corporation': 'Empresas',
    'menu-subscription': 'Assinatura',
    'menu-addon': 'Adicionais',
    'menu-partner': 'Parceiros',
    'menu-rating': 'Feedback',
    'menu-rating-rating': 'Avaliações',
    'menu-rating-useful': 'Foi útil',
    'menu-rating-statistics': 'Estatísticas',
    'menu-statistics': 'Estatísticas',
    'menu-specialties': 'Especialidades',
    'menu-packs': 'Pacotes',
    'menu-products': 'Produtos',
    'menu-pins': 'PINs',
    'menu-epay-transactions': 'Transações da Epay',
    'menu-coupon': 'Cupom de Desconto',
    'menu-schedules': 'Horários médicos',
    'menu-chats': 'Chats',
    'menu-faq': 'Perguntas Frequentes',
    'menu-report': 'Relatórios',
    'menu-report-peoples': 'Clientes',
    'menu-report-subscription': 'Assinatura',
    'menu-report-addon': 'Adicionais',
    'menu-report-rating': 'Avaliações',
    'menu-report-push': 'Notificações',
    'menu-images': 'Imagens',
    'menu-locize': 'Traduções',
    'menu-zendesk': 'Zendesk',
    'menu-package-billings': 'Compra de adicionais',
    'menu-plan-billings': 'Compra de assinaturas',
    'menu-partner-dashboard': 'Dashboard de Parceiros',
    'menu-appointment-categories': 'Categorias de Consulta',
    'menu-appointment-tags': 'Sintomas',
    'menu-files': 'Arquivos',
    'menu-reports': 'Relatórios',
    'menu-reports-users-actives': 'Usuários ativos',
    'menu-reports-packages-actives': 'Adicionais ativos',
    'menu-reports-packages-especialty-actives': 'Especialistas',
    'menu-reports-ids-integration': 'Integração IDS',
    'menu-automations': 'Automações',
    'menu-whatsapp-campaign': 'Convite WhatsApp',
    'menu-appointment-confirmations': 'Confirmação Agendamento',
    'menu-pre-registration-campaign': 'Ativação Pré-cadastro',
    'menu-infobip-access': 'Acesso à Infobip',

    wait_load: '* Aguarde o carregamento por completo',

    key_before_attendant: 'Antes da triagem',
    key_before_doctor: 'Antes do médico',

    'logoff-title': 'Sair',
    'logoff-descrition': `Realmente deseja sair do ${appName}?`,
    'logoff-cancel': 'Cancelar',
    'logoff-confirm': 'Sair',

    'form-submit': 'SALVAR',
    'form-cancel': 'CANCELAR',
    'form-saveAndContinue': 'Salvar e continuar',

    'input-select-placeholder': 'Selecione',
    'input-select-loading': 'Carregando...',
    'input-select-no-options': 'Nenhuma opção encontrada',

    true: 'Sim',
    false: 'Não',
    NA: 'N/A',
    loading: 'Carregando',
    sendNotificationTo: 'Enviar notificação para {{name}}',

    'request-error': 'Erro ao realizar uma Requisição',
    Send: 'Enviar',
    Cancel: 'Cancelar',

    'delete-modal-text': 'Deseja mesmo excluir',
    'delete-modal-title': 'Atenção',
    'delete-modal-delete': 'Excluir',
    'delete-modal-cancel': 'Cancelar',

    'delete-toast-success': 'Excluído com sucesso',
    'delete-toast-fail': 'Falha na exclusão',

    dropzone_placeholder: 'Insira sua imagem',
    dropzone_file_placeholder: 'Inserir Anexo',
    importFile: 'Importar arquivo',
    'search-toast-error':
      'Insira uma palavra com mais de 3 caracteres para poder pesquisar',
    'search-placeholder': 'Busca',

    cancel: 'cancelar',
    send: 'Enviar',
    close: 'Fechar',
    terms_of_use: 'Termos de Uso',
    privacy_policy: 'Política de Privacidade',
    cookies_policy: 'Política de Cookies',
    and: 'e',
    i_agree: 'Eu li e aceito ',
    dont_agree: 'Recuso',
    why_cookies: 'Eles são utilizados para aprimorar a sua experiência. LEIA ',
    we_use_cookies: 'Nós utilizamos Cookies',
    only: 'Filtro',
    actives: 'Ativos',
    not_actives: 'Inativos',
    responsible: 'Responsável',
    both: 'Ativos e Inativos',
    status: 'Status',
    active: 'Ativo',
    not_active: 'Inativo',
    activated_at: 'Ativo em',
    inactivated_at: 'Inativo em',
    consider_appointments: 'Considerar consultas',
    only_dependents: 'Somente dependentes',
    cumulative: 'Cumulativo',
    all: 'Todas',
    specialty: 'Especialidade',
    mercadopago: 'Mercado Pago',
    cielo: 'Cielo',
    braspag: 'Braspag',
    'reject-doc-toast-sucess': 'Documento excluído com sucesso',
    'verify-doc-toast-sucess': 'Documento aceito com sucesso',
    'reject-doc-toast-sucess-plural': 'Documentos excluídos com sucesso',
    'verify-doc-toast-sucess-plural': 'Documentos aceitos com sucesso',
  },
};
